import UrlHandlerApiService from "@/core/services/url-handler.service";
import Vue from "vue";

const CoinsApiService = {
  URL: "",
  async init() {
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  getAllCoins() {
    return Vue.axios.post(`${this.URL}api/promo/v1/coins/getCoins`, {}).catch(error => {
      throw new Error(`[KT] CoinsApiService ${error}`);
    });
  },
  createCoin(coin) {
    return Vue.axios.post(`${this.URL}api/promo/v1/coins`, coin).catch(error => {
      throw new Error(`[KT] CoinsApiService ${error}`);
    });
  },
  updateCoin(coin) {
    return Vue.axios.put(`${this.URL}api/promo/v1/coins`, coin).catch(error => {
      throw new Error(`[KT] CoinsApiService ${error}`);
    });
  },
  deleteCoin(coinId) {
    return Vue.axios.delete(`${this.URL}api/promo/v1/coins?id=${coinId}`).catch(error => {
      throw new Error(`[KT] CoinsApiService ${error}`);
    });
  }
};

export default CoinsApiService;
